export { default as PrivacyPolicy } from "./PrivacyPolicy";
export { default as NotificationSettings } from "./NotificationSettings";
